import React from 'react';
import { useEffect, useState } from 'react'
import { Grid, Divider, Typography, Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDirectoryAssets, displayAsset } from '../../../../store/assets/actions';
import LoaderWithProgress from "../../../atoms/loader/LoaderWithProgress.js";
import DirectoryButton from "../../../atoms/Directory/DirectoryButton";
import ImageThumbnail from "../../../atoms/Directory/ImageThumbnail";
import BreadCrumb from '../../../atoms/breadcrumb/';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { getDetailsFromUrl } from '../../../../services/blueprint'

import { makeStyles } from '@material-ui/styles';
import CreateFolder from '../../assets/CreateFolder';
import UploadAsset from '../../assets/UploadAsset';
import { getUploadProgress } from '../../../../store/global/selectors.js';

const assetUploadOptions = [
    {
        title: 'Create a directory',
        value: 'folder'
    },
    {
        title: 'Upload a file',
        value: 'file'
    }
]

const useStyles = makeStyles((theme) => ({
    emptyFolder: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 340px)',
    }
}));

export default function AssetsExplorer({ setSelectedFile, selectedFile, drawerType, setDrawerType }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { slug } = getDetailsFromUrl();

    const uploads = useSelector(getUploadProgress);

    console.log("uploads---", uploads)

    const [isFetching, setIsFetching] = useState(false);
    const [assetsList, setAssetsList] = useState([]);
    const [breadCrumbArray, setBreadCrumbArray] = useState([{ label: "Assets", id: null }]);
    const [anchorElement, setAnchorElement] = useState(null);
    const [parentId, setParentId] = useState(null)

    const fetchParentAssets = (parentId) => {
        setIsFetching(true);
        setAssetsList([])
        dispatch(fetchDirectoryAssets(parentId)).then(response => {
            const folders = response.data.filter(item => item.type === 'folder');
            const images = response.data.filter(item => {
                if (item.type == "file" && (item.assetName?.endsWith('.png') || item.assetName?.endsWith('.jpg') || item.assetName?.endsWith('.jpeg'))) {
                    return item;
                }
            });

            // For fetching the url of images
            const promises = images.map(image => {
                return displayAsset(image, slug).then(resp => {
                    if (resp.status === true) {
                        image.url = resp.filePath;
                        image.filePath = resp.url;
                        return image;
                    }
                });
            })
            Promise.all(promises).then(result => {
                setAssetsList([...folders, ...(result || [])]);
                setIsFetching(false);
            })
        })
    }

    useEffect(() => {
        if (uploads && uploads.length > 0) {
            const isAnyCompleted = uploads.find(item => item.status === "completed" && item.progress === 100);
            if (isAnyCompleted) {
                onAssetActionComplete();
            }
        }
    }, [uploads]);


    useEffect(() => {
        if (!drawerType) {
            fetchParentAssets(breadCrumbArray[breadCrumbArray.length - 1].id || null);
        }
    }, []);

    const onAssetActionComplete = () => {
        setAnchorElement(null);
        setDrawerType(null);
        fetchParentAssets(breadCrumbArray[breadCrumbArray.length - 1].id || null);
    }


    const onOpenDirectory = (item) => {
        setBreadCrumbArray((prevBreadcrumbs) => [...prevBreadcrumbs, { label: item.assetName, id: item._id }]);
        fetchParentAssets(item._id);
        setParentId(item._id)
        setSelectedFile(undefined);
    }

    const onSelectImage = (item) => {
        setSelectedFile(item);
    }

    const onBreadCrumbClick = (breadcrumb) => {
        const index = breadCrumbArray.findIndex(item => item.id === breadcrumb.id);
        if (index !== -1) {
            breadCrumbArray.splice(index + 1);
            setBreadCrumbArray(breadCrumbArray);
            fetchParentAssets(breadcrumb.id);
            setParentId(breadcrumb.id)
            setSelectedFile(undefined);
        }

    }

    /**
     * @param event is the event object of the clicked dom
     * This function set the clicked element's target into the anchor element. So the menu will be get opened besided the clicked dom element
     */
    const handleMenuOpening = (event) => setAnchorElement(event.currentTarget)

    /**
     * @param optionType is the type of the assetUpload it can be two values file or directory
     * This function will set the assetUploadType and then assign null to the anchor element. So, the menu will be get closed
     */
    const handleAssetUpload = (optionType) => {
        setDrawerType(optionType);
        handleClose();
    }

    /**
     * This function will assign null to the anchorElement. So the menu will be get closed
     */
    const handleClose = () => {
        setAnchorElement(null)
    }


    return (
        <Grid container direction={"row"} id={"imageMapAssetExplorer"}>
            <Grid item xs={12}>
                <Grid container xs={12} direction='row' alignItems='center' justify='space-between'>
                    <BreadCrumb items={breadCrumbArray} isClickable={true} onClick={onBreadCrumbClick} />
                    <Box>
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleMenuOpening}
                            id={"optionsButton"}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id='asset-menu'
                            anchorEl={anchorElement}
                            open={Boolean(anchorElement)}
                            keepMounted
                            onClose={handleClose}
                        >
                            {
                                assetUploadOptions.map((option) => (
                                    ((breadCrumbArray.length >= 3 && option.value !== 'folder') || breadCrumbArray.length < 3) && <MenuItem onClick={() => handleAssetUpload(option.value)}>{option.title}</MenuItem>
                                ))
                            }
                        </Menu>
                    </Box>
                </Grid>
                <Divider style={{ marginBottom: 20 }} />
            </Grid>
            {drawerType === 'folder' ?
                <CreateFolder
                    parent={parentId}
                    onCompletion={onAssetActionComplete}
                    onClose={() => setDrawerType(null)}
                />
                :
                (
                    <Grid item xs={12}>
                        {isFetching && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: 'calc((100vh - 320px)/2)' }} />}
                        {!isFetching &&
                            assetsList.length < 1 ?
                            (<Grid item sx={12} className={classes.emptyFolder}>
                                <Typography variant="body2" >
                                    Folder is empty
                                </Typography>
                            </Grid>)
                            :
                            (<Grid container>
                                {assetsList.filter(element => element.type === "folder").map((item, index) => (
                                    <DirectoryButton key={index} onClick={() => onOpenDirectory(item)} directoryName={item.assetName} />
                                ))}
                                {assetsList.filter(element => element.type === "file").map((item, index) => (
                                    <ImageThumbnail key={index} selected={selectedFile?._id == item?._id} onClick={() => onSelectImage(item)} asset={item} />
                                ))}
                            </Grid>)
                        }
                    </Grid>
                )
            }

            {drawerType === 'file' && <UploadAsset
                parent={parentId}
                onClose={() => setDrawerType(null)}
            />}

        </Grid>
    );
}


